export default __webpack_public_path__ + "static/media/content.ff233b5b.svg";